import { render } from "./MiniSpinner.vue?vue&type=template&id=ceb8700a&scoped=true"
const script = {}

import "./MiniSpinner.vue?vue&type=style&index=0&id=ceb8700a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb8700a"]])

export default __exports__